import * as d3 from 'd3'
export default {
  
  methods: {

    draw_Radar() {

      let radarData = this.series.item.reverse()
      let radius = this.radar.ridius / 2
      let angleSlice  = 2 * Math.PI / this.series.item.length

      //Circular segments
      let chart = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.radar.x - (radius)}, ${this.radar.y - (radius)})`)

      let gridNo = 5
      for(let j=0; j<gridNo; j++) {
        let levelFactor = radius * ((j + 1) / gridNo)
        chart
        .append('circle')
        .attr('cx', radius).attr('cy', radius)
        .attr('r', levelFactor).attr('fill', '#fff')
        .attr('stroke-width', (j == (gridNo-1)) ? this.grids.sWidth : this.grids.sWidth*.7)
        .attr('stroke', this.grids.stroke)
        .attr('opacity', (j == (gridNo-1)) ? this.grids.opacity : this.grids.opacity*.7)

        if(this.axes.display == 'Y') {
          chart
          .append('text')
          .attr('transform', `translate(${radius - levelFactor + 2}, ${radius-levelFactor})`)
          .attr('x', levelFactor * (1 - Math.sin(0))).attr('y', levelFactor * (1 - Math.cos(0)))
          .attr('fill', this.axes.tColor).attr('font-size', this.axes.tSize)
          .text(`${(j+1)*100/gridNo}%`)
        }
      }
      
      // group of the axes in the Radar Chart 
      this.series.item.forEach((d,i)=> {
        chart
        .append('line')
        .attr('x1', radius).attr('y1', radius)
        .attr('x2', radius * (1 - Math.sin(i * angleSlice))).attr('y2', radius * (1 - Math.cos(i * angleSlice)))
        .style('stroke', this.axes.stroke).attr('stroke-width', this.axes.sWidth)
        .attr('opacity', this.axes.opacity)

        chart
        .append('text')
        .attr('transform', 'translate(0, 0)')
        .attr('x', radius * (1 - this.series.factor * Math.sin(i * angleSlice)) - 60 * Math.sin(i * angleSlice))
        .attr('y', radius * (1 - Math.cos(i * angleSlice)) - 20 * Math.cos(i * angleSlice) + this.series.tSize*0.36)
        .attr('font-size', this.series.tSize).attr('font-weight', this.series.fWeight)
        .attr('text-anchor', 'middle')
        .attr('fill', this.series.tColor)
        .text(d.name)
        .call(this.event_Link, d)
      })

      //Scale for the radius
      let dataValues = JSON.parse(JSON.stringify(radarData))
      let rScale = d3.scaleLinear()
      .domain([0, this.grids.maxValue])
      .range([0, radius])

      let defaultRadial = d3.lineRadial()
      .angle((_, i) => (i * angleSlice) * -1).radius(() => rScale(0))
      
      let lineRadial = d3.lineRadial()
      .angle((_, i) => (i * angleSlice) * -1).radius(d => rScale(d.value))

      defaultRadial.curve(d3.curveCardinalClosed.tension(0))
      lineRadial.curve(d3.curveCardinalClosed.tension(0))
      
      chart
      .append('g')
      .style('fill-opacity', this.radar.opacity)
      .attr('transform', `translate(${radius}, ${radius})`)

      .append('path')
      .attr('d', defaultRadial(dataValues))
      .attr('stroke-width', this.radar.sWidth)
      .attr('stroke', this.radar.stroke)
      .attr('fill', `url(#${this.localId}_${this.radar.color})`)
      .transition().duration(700)
      .attr('d', lineRadial(dataValues))
      
      // Draw Node on area
      dataValues = []
      radarData.forEach((d,i)=> {
        dataValues.push([
          radius * (1 - (parseFloat(Math.max(d.value, 0)) / this.grids.maxValue) * Math.sin(i * angleSlice)), 
          radius * (1 - (parseFloat(Math.max(d.value, 0)) / this.grids.maxValue) * Math.cos(i * angleSlice)),
        ])
      })

      dataValues.forEach((d,i)=> {
        chart
        .append('circle')
        .attr('cx', radius).attr('cy', radius)
        .attr('r', this.radar.node).attr('fill', this.radar.stroke)
        .transition().duration(700).attr('cx', d[0]).attr('cy', d[1])

        chart
        .append('text')        
        .attr('x', radius).attr('y', radius + this.value.tSize*0.36)
        .attr('font-size', this.value.tSize).attr('fill', this.value.tColor)
        .attr('text-anchor', 'middle')
        .attr('opacity', (this.value.display == 'Y') ? 1 : 0)
        .text(`${Number(radarData[i].value).toFixed(1)}%`)
        .transition().duration(700).attr('x', d[0]).attr('y',d[1]-5)
      })
      
    },
  }
}